import { BaseBuyBonusPopup } from './BaseBuyBonusPopup';
import { buyBonusResources } from '../../../core/gameConstants';

class BuyBonusMobilePopup extends BaseBuyBonusPopup {
  constructor() {
    super();
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(buyBonusResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  async onLoad() {
    return this.loadResource();
  }

  executeMobile({ root }) {
    return this.loadResource([]).then(() => {
      const container = this.getPopup({
        onClick: this.onClick(),
      });
      root.addChild(container);
    });
  }
}

export const buyBonusMobilePopup = new BuyBonusMobilePopup();
